import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const CasinoAds = lazyRouteComponent(() => import('../pages/casino-ads'))

export const casinoAdsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/casino-ads',
  component: CasinoAds,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
